// src/components/Guidelines/Guidelines.js
import React from 'react';
import Header from '../Header/header'; // Assuming Header component is in '../Header/header'
import './guidelines.css'; // Import the CSS file

const Guidelines = () => {
    return (
        <div className="guidelines-container">
            <Header /> {/* Include your Header component */}

            <h1 className="guidelines-title">Employee of the Quarter Voting Guidelines</h1>

            <section className="guidelines-section">
                <h2 className="section-heading">Introduction</h2>
                <p>Welcome to the Employee of the Quarter Voting process. Please read the following guidelines carefully to understand the nomination and voting procedures.</p>
            </section>

            <section className="guidelines-section">
                <h2 className="section-heading">Voting Stages Overview</h2>

                <div className="stage-card">
                    <h3 className="stage-title">Stage One: Department Nominations</h3>
                    <p>Each individual may nominate a candidate from within their department. Line Supervisors and Heads of Departments are also eligible for nomination at this stage.</p>
                    <h4 className="sub-heading">Voting Weights for Nominations:</h4>
                    <ul>
                        <li><strong>Head of Department</strong> nomination: 3 votes.</li>
                        <li><strong>Line Supervisor</strong> nomination (per section): 2 votes.</li>
                        <li><strong>All other staff</strong>: 1 vote.</li>
                        <li>The <strong>CEO’s nomination</strong> carries a weight of 2 votes when voting for a Head of Department or Line Supervisor, but carries a weight of 3 votes when nominating other staff.</li>
                    </ul>
                    {/* <p className="timeline"><strong>Timeline:</strong> Nominations for Stage One of Q1 will be received from today, June 18, 2025 till 16:00 EAT.</p> */}
                </div>

                <div className="stage-card">
                    <h3 className="stage-title">Stage Two: Cross-Department Voting</h3>
                    <p>Winners from each department in Stage One will become the candidates for Stage Two.</p>
                    <h4 className="sub-heading">Voting Weights:</h4>
                    <ul>
                        <li>Votes from the same department: 1 vote.</li>
                        <li>Votes from a different department: 2 votes.</li>
                    </ul>
                    <p className="participation-note"><strong>Participation Requirement:</strong> All departments are required to participate in voting during this stage.</p>
                    {/* <p className="timeline"><strong>Timeline:</strong> Dates for Stage Two will be announced after the completion of Stage One.</p> */}
                </div>
            </section>

            <section className="guidelines-section">
                <h2 className="section-heading">Participation Guidelines</h2>
                {/* <h3 className="sub-heading">Voting Window:</h3>
                <p>Each individual has a voting window of <strong>3 minutes</strong>. Votes not submitted before the timer expires will not be counted. Please ensure you submit your vote within this timeframe.</p> */}

                <h3 className="sub-heading">Eligibility to Vote:</h3>
                <p>Employees who have not completed a full quarter are <strong>NOT</strong> eligible to vote.</p>

                <h3 className="sub-heading">Eligibility for Nomination:</h3>
                <p>Each individual may nominate a candidate from within their department. Line Supervisors and Heads of Departments are also eligible for nomination at this stage.</p>

                <h3 className="sub-heading">Employee of the Year Qualification:</h3>
                <p>To be eligible for 'Employee of the Year', an employee must first be voted 'Employee of the Quarter'.</p>
            </section>

            <section className="guidelines-section">
                <h2 className="section-heading">Evaluation Criteria</h2>
                <p>Employee votes for Heads of Department will contribute <strong>25%</strong> to the overall evaluation.</p>
            </section>

            <section className="guidelines-section">
                <h2 className="section-heading">Support & Important Information</h2>
                <h3 className="sub-heading">Login Details:</h3>
                <p>To log in to the voting system, please use your webmail credentials (e.g., username: snamutebi) along with your webmail password.</p>

                <h3 className="sub-heading">Leaderboard Visibility:</h3>
                <p>Real-time updates of the Stage One leaderboard will be broadcast on the Level five screen and are accessible within the system.</p>

                <h3 className="sub-heading">Questions/Support:</h3>
                <p>For any questions or technical assistance, please contact <strong>[systems@renu.ac.ug]</strong>.</p>
            </section>
        </div>
    );
};

export default Guidelines;